(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buzz-collection-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('buzz-collections')) {
  customElements.define('buzz-collections', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.buzz-collections__track');
      this.controls = this.querySelector('.buzz-collections__controls');
      this.toggle = this.querySelector('[data-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
      this.hovered = false;
      this.focused = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') { this.paused = true; this.sync(); } }, options);
this.addEventListener('focusin', e => {
  this.focused = !e.target.closest('[data-toggle]');
  this.sync();
}, options);      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.sync(); } }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
      this.resize = new ResizeObserver(() => this.sync());
      this.resize.observe(this.track);
      this.visible = false;
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
      this.observer.observe(this);
      this.sync();
    }
    sync() {
      clearInterval(this.timer);
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.controls.hidden = !overflow;
      this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
      if (overflow && !this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) {
        this.timer = setInterval(() => this.move(1), Number(this.dataset.delay) || 5000);
      }
    }
    move(direction) {
      const cards = [...this.track.querySelectorAll('.buzz-collections__card')];
      if (!cards.length) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      let target = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= max - 2) target = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) target = max;
      this.track.scrollTo({left: Math.max(0, Math.min(max, target)), behavior: this.motion.matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
